import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
// Components
import Sidebar from "../Nav/Sidebar";
import Backdrop from "../Elements/Backdrop";
// Assets

import BurgerIcon from "../../assets/svg/BurgerIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { PhoneCall, Smartphone } from "lucide-react";
import PageScrollProgress from "./PageScrollProgress";

export default function TopNavbar() {
  const [sidebarOpen, toggleSidebar] = useState(false);

  const [y, setY] = useState(window.scrollY);
  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const formations = [
    "Soft Skills - Gestion du Stress - Initiation",
    "Soft Skills - Utiliser sa Voix pour Convaincre - Initiation",
    "Soft Skills - Les Secrets du Body Language - Initiation",
    "Soft Skills - Maîtriser votre Communication - Initiation",
    "Soft Skills - Se Présenter en 10 Min - Initiation",
    "Soft Skills - Construire son Personal Branding - Initiation",
    "Soft Skills - Maîtriser la Pensée Critique - Initiation",
    "Soft Skills - Découvrir la PNL - Initiation",
    "Soft Skills - Réussir vos présentations pour convaincre",
    "Soft Skills - Réussir votre présentation virtuelle",
    "Soft Skills - Parler en public – Gérer la pression",
    "Soft Skills - Gestion du stress",
    "Soft Skills - Intelligence émotionnelle",
    "Soft Skills - Maîtriser les relations publiques",
    "Soft Skills - Réussir son entretien",
    "Soft Skills - Conquérir tous les publics",
    "Soft Skills - L’Écoute active",
    "Management - RH",
    "Infographie",
    "Productivité de l’entreprise",
    "Reconversion Professionnelle – Coaching & Accompagnement",
    "CAO - DAO",
    "Développement Web",
    "Kinésithérapie",
    "Vente et Marketing Digital",
    "Sécurité",
    "CACES – Certificat d’Aptitude à la Conduite En Sécurité",
    "Coiffure et Esthétique",
    "Langue Anglais - Débutant (A1-A2)",
    "Préparation à l'Examen Anglais - Linguaskill",
    "Préparation à l'Examen Anglais - IELTS",
    "Préparation à l'Examen Anglais - TOEFL",
    "Préparation à l'Examen Anglais - Linguaskill",
    "Préparation à l'Examen Anglais - IELTS",
    "Préparation à l'Examen Anglais - Cambridge",
    "Préparation à l'Examen Anglais - TOEIC",
    "Langue Anglais Professionnel Langue Étrangère",
    "Langue Anglais Langue Étrangère - Niveau Débutant",
    "Langue Anglais - Médical (B1-B2)",
    "Langue Anglais - Médical (A1-A2)",
    "Langue Anglais - Avancé (C1-C2)",
    "Langue Anglais - Intermédiaire (B1-B2)",
    "Langue Russe - Débutant (A1-A2)",
    "Langue Portugais - Débutant (A1-A2)",
    "Langue des Signes Française - Niveau A1-A2",
    "Langue Japonais - Débutant (A1-A2)",
    "Langue Italien - Débutant (A1-A2)",
    "Langue Français Langue Étrangère (FLE) Niveau B1",
    "Langue Français Langue Étrangère (FLE) Niveau A1-A2",
    "Préparation à l’Examen Espagnol SIELE",
    "Préparation à l’Examen Espagnol DELE",
    "Langue Espagnol - Avancé (C1-C2)",
    "Langue Espagnol - Intermédiaire (B1-B2)",
    "Langue Espagnol - Débutant (A1-A2)",
    "Langue Arabe - Intermédiaire (B1-B2)",
    "Langue Arabe - Débutant (A1-A2)",
    "Langue Allemand - Débutant (A1-A2)",
    "Sauveteur Secouriste du Travail (SST)",
    "Intelligence Artificielle (IA)",
    "Hygiène et sécurité alimentaire - Méthode HACCP",
    "Hygiène Alimentaire et Gestion des Allergènes",
    "COMPTABILITÉ - Initiation",
    "COMPTABILITÉ - Les Fondamentaux",
    "COMPTABILITÉ - UE1 - Gestion de Paie",
    "COMPTABILITÉ - UE2 - Calculer le Bulletin de Paie",
    "COMPTABILITÉ - UE3 - Le Prélèvement à la Source",
    "COMPTABILITÉ - UE4 - Identifier les aménagements du temps de travail",
    "COMPTABILITÉ - UE5 - Identifier le rôle des IRP et la notion de confidentialité",
    "COMPTABILITÉ - UE6 - Calculer un bulletin de paie avec les éléments variables",
    "COMPTABILITÉ - UE7 - Calculer une paie “particulière”",
    "COMPTABILITÉ - UE8 - Calculer la paie de départ - Le SDTC",
    "COMPTABILITÉ - UE9 - Calculer les éléments post paie",
    "COMPTABILITÉ - UE10 - Simulation d'un oral blanc pour le titre de gestionnaire de paie",
  ];

  useEffect(() => {
    window.addEventListener("scroll", () => setY(window.scrollY));
    return () => {
      window.removeEventListener("scroll", () => setY(window.scrollY));
    };
  }, [y]);

  // useEffect(() => {
  //   // Sort once on mount
  //   const sorted = [...formations].sort((a, b) =>
  //     a.localeCompare(b, "fr", { sensitivity: "base" })
  //   );
  //   setSortedFormations(sorted);
  // }, []);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    if (value) {
      const filteredSuggestions = formations.filter((formation) =>
        formation.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filteredSuggestions);
    } else {
      setSuggestions([]);
    }
  };
  const location = useLocation();
  const navigate = useNavigate();
  const handleClick = (e) => {
    if (location.pathname !== "/") {
      e.preventDefault(); // Prevent default Link behavior
      navigate("/"); // Navigate to the landing page
    }
  };

  return (
    <>
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      {sidebarOpen && <Backdrop toggleSidebar={toggleSidebar} />}
      <Wrapper
        className="flexCenter animate whiteBg"
        style={y > 120 ? { height: "80px" } : { height: "110px" }}
      >
        <NavInner className="container flexSpaceCenter">
          <Link
            onClick={handleClick}
            className="pointer flexNullCenter"
            to="home"
            smooth={true}
          >
            <img
              alt="Logo Valacademy Formations"
              src={require("../../assets/img/Logo/Logo_Beige.png")}
              style={{
                width: y > 120 ? 80 : 120,
                height: y > 120 ? 80 : 120,
                transition: "all 0.5s ease-in-out",
              }}
            />
          </Link>
          <BurderWrapper
            className="pointer"
            onClick={() => toggleSidebar(!sidebarOpen)}
          >
            <BurgerIcon />
          </BurderWrapper>
          <SearchWrapper>
            <SearchInput
              type="text"
              placeholder="Trouvez votre formation idéale..."
              value={searchTerm}
              onChange={handleInputChange}
            />
            <SearchIcon className="fas fa-search"></SearchIcon>
            {suggestions.length > 0 && (
              <SuggestionsList>
                {suggestions.map((suggestion, index) => (
                  <SuggestionItem
                    key={index} // Use index if there's no `id`
                    onClick={() =>
                      (window.location.href = "/formation/" + suggestion)
                    }
                  >
                    {suggestion}
                  </SuggestionItem>
                ))}
              </SuggestionsList>
            )}
          </SearchWrapper>
          <UlWrapper className="flexNullCenter">
            <li className="semiBold font15 pointer">
              <Link
                onClick={handleClick}
                activeClass="active"
                style={{ padding: "10px 15px" }}
                to="home"
                spy={true}
                smooth={true}
                offset={-80}
              >
                Accueil
              </Link>
            </li>
            <li className="semiBold font15 pointer">
              <Link
                onClick={handleClick}
                activeClass="active"
                style={{ padding: "10px 15px" }}
                to="services"
                spy={true}
                smooth={true}
                offset={-80}
              >
                Services
              </Link>
            </li>
            <li className="semiBold font15 pointer">
              <Link
                onClick={handleClick}
                activeClass="active"
                style={{ padding: "10px 15px" }}
                to="Aide & Avis"
                spy={true}
                smooth={true}
                offset={-80}
              >
                Aide & Avis
              </Link>
            </li>
            {/* <li className="semiBold font15 pointer">
              <Link
                activeClass="active"
                style={{ padding: "10px 15px" }}
                to="blog"
                spy={true}
                smooth={true}
                offset={-80}
              >
                Blog
              </Link>
            </li> */}
            {/* <li className="semiBold font15 pointer">
              <Link
                activeClass="active"
                style={{ padding: "10px 15px" }}
                to="pricing"
                spy={true}
                smooth={true}
                offset={-80}
              >
                Pricing
              </Link>
            </li> */}
            <li className="semiBold font15 pointer">
              <Link
                onClick={handleClick}
                activeClass="active"
                style={{ padding: "10px 15px" }}
                to="contact"
                spy={true}
                smooth={true}
                offset={-80}
              >
                Contact
              </Link>
            </li>
          </UlWrapper>
          <UlWrapperRight className="flexNullCenter">
            <li className="semiBold font15 pointer" style={{ marginRight: 20 }}>
              <div className="row" style={{ marginTop: 0, color: "green" }}>
                <a
                  href="tel:+33162370262"
                  className="row"
                  style={{ textDecoration: "none", textwieght: "bold" }}
                >
                  <PhoneCall size={22} style={{ marginRight: 5 }} />
                  0162370262
                </a>
              </div>
              <div className="row" style={{ marginTop: 5, color: "green" }}>
                <a
                  href="tel:+33658684043"
                  style={{
                    textDecoration: "none",
                    textwieght: "bold",
                  }}
                  className="row"
                >
                  <Smartphone size={22} style={{ marginRight: 5 }} />
                  0658684043
                </a>
              </div>
            </li>
            {/* <li className="semiBold font15 pointer flexCenter">
              <a
                href="/"
                className="radius8 lightBg"
                style={{ padding: "10px 15px" }}
              >
                Get Started
              </a>
            </li> */}
          </UlWrapperRight>
        </NavInner>
        <ProgressWrapper>
          <PageScrollProgress />
        </ProgressWrapper>
      </Wrapper>
    </>
  );
}

const ProgressWrapper = styled.div`
  width: 100%;
  position: absolute;
  bottom: 0;
  transition: width 0.2s ease-out;
`;
const Wrapper = styled.nav`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
`;
const NavInner = styled.div`
  position: relative;
  height: 100%;
`;
const BurderWrapper = styled.button`
  outline: none;
  border: 0px;
  background-color: transparent;
  height: 100%;
  padding: 0 15px;
  display: none;
  @media (max-width: 760px) {
    display: block;
  }
`;
const UlWrapper = styled.ul`
  display: flex;
  @media (max-width: 760px) {
    display: none;
  }
`;

const SearchIcon = styled.i`
  position: absolute;
  right: 25%;
  top: 30%;
  color: #aaa;
`;

const UlWrapperRight = styled.ul`
  @media (max-width: 760px) {
    display: none;
  }
`;
const SearchWrapper = styled.div`
  position: relative;
  width: 250px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const SearchInput = styled.input`
  width: 120%;
  margin-left: -15%;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  outline: none;
`;

const SuggestionsList = styled.ul`
  position: absolute;
  top: 100%;
  margin-left: -15%;
  left: 0;
  width: 120%;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 5;
`;

const SuggestionItem = styled.li`
  display: flex;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  font-size: 14px;
  &:hover {
    background: #f0f0f0;
  }
`;
